"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Bath = function Bath(_ref) {
  var size = _ref.size,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, rest), _react.default.createElement("path", {
    d: "M43.194 44.313H8.807c-3.753 0-6.807-2.85-6.807-6.35V29.6a1 1 0 0 1 1-1h46a1 1 0 0 1 1 1v8.362c0 3.5-3.053 6.35-6.806 6.35zM4 30.6v7.362c0 2.398 2.156 4.35 4.807 4.35h34.387c2.65 0 4.806-1.952 4.806-4.35V30.6H4z"
  }), _react.default.createElement("path", {
    d: "M16.53 48h-5.412a1 1 0 0 1-1-1v-3.688a1 1 0 0 1 1-1h5.411a1 1 0 0 1 1 1V47a1 1 0 0 1-1 1zm-4.412-2h3.411v-1.688h-3.41V46zM40.206 48h-5.412a1 1 0 0 1-1-1v-3.688a1 1 0 0 1 1-1h5.412a1 1 0 0 1 1 1V47a1 1 0 0 1-1 1zm-4.412-2h3.412v-1.688h-3.412V46zM5.706 29.979a1 1 0 0 1-1-1V11.587C4.706 7.403 8.362 4 12.856 4c3.297 0 5.706 1.443 6.965 4.175a1 1 0 0 1-1.816.838C17.07 6.985 15.385 6 12.855 6c-3.39 0-6.149 2.506-6.149 5.587v17.392a1 1 0 0 1-1 1z"
  }), _react.default.createElement("path", {
    d: "M17.883 16.266a1 1 0 0 1-.988-1.153l1.03-6.672c.118-.748.813-1.25 1.573-1.156l7.244.951a1 1 0 0 1 .44 1.814l-8.73 6.038a1 1 0 0 1-.57.178zm1.927-6.922l-.584 3.777 4.683-3.24-4.1-.537zM21.531 19.269a.997.997 0 0 1-.77-.362l-.423-.51a1 1 0 0 1 1.539-1.277l.423.51a1 1 0 0 1-.769 1.639zM25.59 18.022a.997.997 0 0 1-.77-.36l-.424-.51a1 1 0 0 1 1.54-1.278l.422.51a1 1 0 0 1-.768 1.638zM28.296 15.53a.997.997 0 0 1-.77-.362l-.423-.51a1 1 0 0 1 1.539-1.277l.422.51a1 1 0 0 1-.768 1.638zM24.237 24.255a.997.997 0 0 1-.77-.361l-.423-.51a1 1 0 0 1 1.539-1.278l.423.51a1 1 0 0 1-.769 1.639zM28.296 23.008c-.287 0-.572-.123-.77-.36l-.423-.51a1.002 1.002 0 0 1 .13-1.409 1.002 1.002 0 0 1 1.409.13l.422.51a1.002 1.002 0 0 1-.768 1.639zM31.002 20.516a.997.997 0 0 1-.77-.362l-.423-.51a1 1 0 0 1 1.539-1.277l.423.51a1 1 0 0 1-.769 1.639z"
  }));
};

Bath.displayName = "Bath";
Bath.defaultProps = {
  size: 24,
  color: "currentColor"
};
var _default = Bath;
exports.default = _default;